export class NavigationError extends Error {
    constructor(message){
        super(`[@sail/navigation] ${message}`);
    }
}

//# sourceMappingURL=errors.js.map